import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../utils/request';
import { METHOD_POST } from '../../constants/api';
import getRoles from './getRoles';

const postRoles = createAsyncThunk('roles/postRoles',
  async ({ name, permissions } = {}, { dispatch, rejectWithValue }) => {
    try {
      const { id } = await authSet(METHOD_POST, '/roles', { name, permissions });
      dispatch(getRoles());
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default postRoles;
